/**
 * RCC Surface #11 — Weekly FSR-UB (Undeliverable / Unclaimed Balance) review.
 */

import { SurfaceHeader } from '../components/SurfaceHeader';
import { ComingSoonPanel } from '../components/ComingSoonPanel';

export function FsrUbWeekly(): JSX.Element {
  return (
    <div>
      <SurfaceHeader
        title="FSR-UB Weekly"
        scope="Weekly Undeliverable / Unclaimed Balance review. Flags stale addresses and uncashed-item aggregates for due-diligence touch."
        surfaceNumber={11}
        role="FSR"
      />
      <ComingSoonPanel
        headline="Weekly FSR-UB review"
        body="UI scaffolds the queue; backend feed pulls from Core Director weekly export once the integration is in place."
        route="/v3/audit-reports/fsr-ub (PLANNED)"
      />
    </div>
  );
}
